import { photoHttp } from './photoHttp';
const photoDomain = 'http://127.0.0.1:38088/';

export default {
  getResolution(params) {
    return photoHttp.post(`${photoDomain}param=get`, params);
  },
  setResolution(params) {
    return photoHttp.post(`${photoDomain}param=set`, params);
  },
  grabImageBase64(params) {
    return photoHttp.post(`${photoDomain}video=grabimage`, params);
  },
  showSign(params) {
    return photoHttp.post(`${photoDomain}sign=start`, params);
  },
  getVideStatus(params) {
    return photoHttp.post(`${photoDomain}video=status`, params);
  }
};
